import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import type { CreditCard } from "@b2bportal/card-api";
import {
  selectCards,
  useListPaymentMethodsMutation,
  useDeletePaymentMethodAndListMutation,
} from "@hsbc/wallet";

const DEFAULT_CARD_LIMIT = 3;

interface UseCardListReturn {
  context: {
    cards: Array<CreditCard>;
    cardLimit: number;
    hasMoreCards: boolean;
  };
  handlers: {
    onShowMoreCards: () => void;
    onDeleteClick: (paymentId: string) => void;
  };
}

export const useCardList = (): UseCardListReturn => {
  const [cardLimit, setCardLimit] = useState<number>(DEFAULT_CARD_LIMIT);
  const cards = useSelector(selectCards);
  const hasMoreCards = cards.length > cardLimit;

  const [triggerListCards] = useListPaymentMethodsMutation({
    fixedCacheKey: "listCards",
  });
  const [triggerDelete] = useDeletePaymentMethodAndListMutation();

  const onDeleteClick = async (paymentId: string) => {
    await triggerDelete({ paymentId });

    triggerListCards();
  };

  const onShowMoreCards = () => {
    setCardLimit(Infinity);
  };

  useEffect(() => {
    triggerListCards();
  }, [triggerListCards]);

  return {
    context: { cards, cardLimit, hasMoreCards },
    handlers: { onShowMoreCards, onDeleteClick },
  };
};
